import React from 'react';
import { CLIENTS } from '../data/mockData';
import { motion } from 'framer-motion';

const ClientLogos = () => {
  // Double the clients for infinite scroll effect
  const scrollClients = [...CLIENTS, ...CLIENTS, ...CLIENTS];

  return (
    <section className="bg-[#FDFEFA] py-10 md:py-14 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 mb-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[#242326] text-2xl md:text-5xl lg:text-[56px] font-light leading-tight tracking-tight font-['Inter']"
        >
          Proud to work with
        </motion.h2>
      </div>

      {/* Scrolling Marquee */}
      <div className="relative">
        {/* Gradient Fades */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#FDFEFA] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#FDFEFA] to-transparent z-10" />

        <div className="flex animate-scroll-left">
          {scrollClients.map((client, i) => (
            <div
              key={`${client}-${i}`}
              className="flex-shrink-0 px-8 md:px-12 flex items-center"
            >
              <span className="text-[#242326]/60 text-xl md:text-2xl lg:text-3xl font-bold tracking-wider uppercase font-['Inter'] whitespace-nowrap hover:text-[#242326] transition-colors duration-300">
                {client}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
